import React, { useCallback } from 'react'
import { ModelForm, hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withForm = Component => props => {
  const { commercial_formula_id, } = hooks.useParams()

  const formProps = {
    name: 'commercial_formula_form',
    model_name: 'commercialformula',
    record_id: commercial_formula_id,
    related_states: [],
    related_searches: [],
    getEmptyForm: useCallback(Callbacks.getEmptyFormHandler(), []),
    recordToForm: useCallback(Callbacks.recordToFormHandler(), []),
    formToRecord: useCallback(Callbacks.formToRecordHandler(), []),
    recordToState: useCallback(Callbacks.recordToStateHandler(), []),
    populate: []
  }

  const mergedProps = {
  }

  return (
    <ModelForm {...formProps}>
      <Component {...mergedProps} />
    </ModelForm>
  )
}

export default withForm
